import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';
import { IProjectData } from '../common/models/project.interface';

const API_URL = environment.API_URL + '/client/';

@Injectable({
  providedIn: 'root',
})
export class ClientsService {
  constructor(private httpService: HttpService) {}

  getAllClients() {
    return this.httpService.get(API_URL);
  }

  getClientById(id: string) {
    return this.httpService.get(API_URL + id);
  }
}
